import {Modal, TextInput, Group, Button, Stack, Text, Divider} from '@mantine/core';
import {DateTimePicker} from '@mantine/dates';
import {useState} from 'react';
import {toast} from "react-toastify";
import {toLocalISOStringWithOffset} from "../../utils/LocalISOStringWithOffsetFormatter";
import api from "../../api";


export default function CreateCampaignModal({opened, onClose}: { opened: boolean; onClose: () => void }) {
    const [startDateTime, setStartDateTime] = useState<Date | null>(null);
    const [endDateTime, setEndDateTime] = useState<Date | null>(null);
    const [campaignName, setCampaignName] = useState('');
    const [campaignCode, setCampaignCode] = useState('');
    const [successCreated, setSuccessCreated] = useState(false);

    const handleSubmit = async () => {
        if (!startDateTime || !endDateTime || !campaignName || !campaignCode) {
            toast.warn('Popunite sva polja.');
            return;
        }

        try {
            const response = await api.post("/admin/campaigns", {
                startDate: toLocalISOStringWithOffset(startDateTime),
                endDate: toLocalISOStringWithOffset(endDateTime),
                name: campaignName,
                code: campaignCode
            });

            if (response.status === 200 || response.status === 201) {
                console.log('Campaign created:', {
                    startDateTime,
                    endDateTime,
                    campaignName,
                    campaignCode
                });
                setSuccessCreated(true);
            } else {
                toast.error("Greška: " + (response.data?.message || 'Nepoznata greška'));
            }

        } catch (error: any) {
            const message = error.response?.data?.message || error.message || 'Greška prilikom kreiranja kampanje.';
            console.error('Error creating campaign:', error);
            toast.error("Greška prilikom kreiranja kampanje: " + message);
        }
    };


    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Kreiraj novu kampanju"
            centered
            size="lg"
        >
            {(!successCreated) ? (
                    <Stack>

                        <TextInput
                            label="Naziv kampanje"
                            placeholder="Unesite naziv"
                            value={campaignName}
                            onChange={(e) => setCampaignName(e.currentTarget.value)}
                            required
                        />

                        <Group grow>
                            <DateTimePicker
                                label="Pocetak kampanje"
                                placeholder="Odaberite datum i vreme"
                                value={startDateTime}
                                onChange={(value) =>
                                    setStartDateTime(value ? new Date(value) : null)
                                }
                                required
                            />
                            <DateTimePicker
                                label="Kraj kampanje"
                                placeholder="Odaberite datum i vreme"
                                value={endDateTime}
                                onChange={(value) =>
                                    setEndDateTime(value ? new Date(value) : null)
                                }
                                required
                            />
                        </Group>

                        <TextInput
                            label="Jedinstveni kod kampanje"
                            placeholder="Unesite jedinstveni kod"
                            value={campaignCode}
                            onChange={(e) => {
                                const cleaned = e.currentTarget.value.toLowerCase().replace(/\s/g, '');
                                setCampaignCode(cleaned);
                            }}
                            required
                        />
                        <br/>
                        <Divider my="xs" label="Uputstvo" labelPosition="center"/>

                        <Text size="xs">* Kod kampanje je kratak identifikator kampanje na osnovu koga klijenti mogu
                            lako da nadju vasu kampanju. Trebalo bi da bude kratak i jasan.</Text>
                        <Text size="xs">* Kod kampanje mora imati samo mala slova i ne sme imati razmake.</Text>

                        <Group mt="md">
                            <Button variant="default" onClick={onClose}>
                                Otkaži
                            </Button>
                            <Button onClick={handleSubmit}>
                                Kreiraj
                            </Button>
                        </Group>
                    </Stack>)
                : (<div className="flex flex-col items-center justify-center">
                    <Text size="sm" fs="italic">Uspesno kreirana kampanja!</Text>
                    <br/>
                    <br/>
                    <br/>
                    <Button variant="default" onClick={onClose}>
                        Nazad
                    </Button>
                </div>)}
        </Modal>
    );
}
